<template>
  <!-- 添加收佣明细弹窗 -->
  <a-modal
    :visible="commissionDetailedVisible"
    title="添加收佣明细"
    :maskClosable="false"
    @cancel="commissionDetailedVisible = false"
    :footer="null"
  >
    <a-form-model ref="ruleForm" :model="commissionDetailedRuleForm" :rules="commissionDetailedRules" v-bind="layout">
      <a-form-model-item label="收款金额" prop="realIncome">
        <a-input v-model="commissionDetailedRuleForm.realIncome" suffix="元" />
      </a-form-model-item>
      <a-form-model-item label="收款时间" prop="proceedsTime">
        <a-date-picker
          showTime
          v-model="commissionDetailedRuleForm.proceedsTime"
          placeholder="请选择收款时间"
          style="width: 100%"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
        />
        <!-- <a-input v-model="commissionDetailedRuleForm.proceedsTime" /> -->
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 10, offset: 10 }">
        <a-button type="primary" @click="commissiondetailOnSubmit('ruleForm')"> 确认 </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import moment from 'moment'
import { addCommissionRecordDetail } from '@/api/system/contract'
import { getYMDHMS, getBeginToday, getCurrentDate } from '@/utils/date'
export default {
  data() {
    return {
      layout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 13 },
      },
      commissionDetailedVisible: false,
      commissionDetailedRuleForm: {
        realIncome: undefined,
        proceedsTime: moment(new Date()),
      },
      commissionDetailedRules: {
        realIncome: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        proceedsTime: [{ required: true, message: '请选择收款时间', trigger: 'change' }],
      },
      contractsDetailsId: '',
      commissionRecordId: '',
    }
  },
  methods: {
    // 添加收佣明细
    commissiondetailOnSubmit(formName) {
      let params = { ...this.commissionDetailedRuleForm }
      // console.log(this.commissionDetailedRuleForm, 'this.commissionDetailedRuleForm.proceedsTime')

      console.log(this.$refs.ruleForm, 'ruleForm')
      this.$refs.ruleForm.validate((valid) => {
        console.log(valid, 'valid')
        if (valid) {
          // console.log(that.commissionDetailedRuleForms, valid, 'this.commissionDetailedRuleForm.proceedsTime')
          params.proceedsTime = moment(params.proceedsTime).format('YYYY-MM-DD HH:mm:ss')
          console.log(params, valid, 'this.commissionDetailedRuleForm.proceedsTime')
          // return
          addCommissionRecordDetail({
            commissionRecordId: this.commissionRecordId,
            ...params,
          }).then((res) => {
            if (res.code === 200) {
              this.$message.success('添加收佣明细成功')
              this.commissionDetailedVisible = false
              this.commissionDetailedRuleForm = {
                realIncome: undefined,
                proceedsTime: moment(new Date()),
              }
              this.commissionRecordId = ''
              // this.getcommissionMsg(this.contractsDetailsId)
              this.$emit('onSuccess', this.contractsDetailsId)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped></style>
